const DEFAULT_PROFILE_PHOTO =
  'https://cxacypehrzratbpjeivm.supabase.co/storage/v1/object/public/uploads/profiles/default_profile_photo.png';

export function getProfileImageUrl(path) {
  if (!path || typeof path !== 'string') {
    return DEFAULT_PROFILE_PHOTO;
  }

  if (path.startsWith('http')) {
    return path; 
  }

  return `https://cxacypehrzratbpjeivm.supabase.co/storage/v1/object/public/${path}`;
}

export default getProfileImageUrl;